// extracted by mini-css-extract-plugin
export var community = "community-module--community--2Q2QH";
export var container = "community-module--container--31U4F";
export var headline = "community-module--headline--2uipy";
export var copy = "community-module--copy--180AG";
export var partners = "community-module--partners--2odC_";